export const RESET_STATE = (state) => {
  state.score = [];
};
